import { ArrayUtil } from './ArrayUtil';
import { Calculator } from './Calculator';

export function Chance() {}

Chance.randomInts = {};

Chance.trueOrFalse = function (possibility?: number) {
  if (possibility == null) possibility = 0.5;
  return Math.random() < possibility ? true : false;
};
Chance.plusOrMinus = function () {
  return Math.random() < 0.5 ? 1 : -1;
};
Chance.randomInt = function (min, max, excluding?) {
  if (excluding == null) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  } else {
    if (excluding.length > (max - min + 1) / 2) {
      // branch algorithm
      const choices = [] as number[];
      for (let i = min; i <= max; i++) {
        if (!ArrayUtil.contains(excluding, i)) choices.push(i);
      }
      return Chance.selectRandom(choices);
    } else {
      let r = Chance.randomInt(min, max);
      while (ArrayUtil.contains(excluding, r)) {
        r = Chance.randomInt(min, max);
      }
      return r;
    }
  }
};
Chance.semiRandomInt = function (min, max, key?) {
  if (key == null) key = 'default';
  let newRandomInt = Calculator.isDefined(Chance.randomInts[key])
    ? Chance.randomInts[key]
    : min;
  Chance.randomInts[key] = newRandomInt;
  while (min < max && newRandomInt == Chance.randomInts[key]) {
    newRandomInt = Chance.randomInt(min, max);
  }
  Chance.randomInts[key] = newRandomInt;
  return newRandomInt;
};
Chance.generateInts = function (num, min, max) {
  const values = [] as number[];
  for (let i = 0; i < num; i++) {
    values[i] = Chance.randomInt(min, max);
  }
  return values;
};
Chance.randomNumber = function (min?, max?, precision?) {
  min = min || 0;
  max = max || 1;
  if (precision == null) {
    return Math.random() * (max - min) + min;
  } else {
    const unit = Math.pow(10, -precision);
    let val = Math.random() * (max - min + unit) + min - unit / 2;
    val = Calculator.round(val, precision);
    return val;
  }
};
Chance.nudge = function (
  val,
  step?: number,
  range?: number,
  possibility?: number,
) {
  step = step || 1;
  range = range || 1;
  possibility = possibility || 1.0;
  if (possibility >= 1 || Chance.trueOrFalse(possibility)) {
    const diff = Calculator.multiply(
      step,
      Chance.plusOrMinus() * Chance.randomInt(1, range),
    );
    return Calculator.add(val, diff);
  } else {
    return val;
  }
};

/* Generation */
Chance.generateNumbers = function (num, min?, max?, precision?) {
  min = min || 0;
  max = max || 1;
  const values = [] as number[];
  for (let i = 0; i < num; i++) {
    values[i] = Chance.randomNumber(min, max, precision);
  }
  return values;
};
Chance.generateCloseNumbers = function (length, num, spread?, min?, max?) {
  spread = spread || 1;

  const arr = [] as number[];
  const numIndexMin = Calculator.isDefined(max)
    ? Math.max(length - 1 - Math.ceil((max - num) / spread), 0)
    : 0;
  const numIndexMax = Calculator.isDefined(min)
    ? Math.min(Math.floor((num - min) / spread), length - 1)
    : length - 1;

  const numIndex = Chance.randomInt(numIndexMin, numIndexMax);
  for (let i = 0; i < length; i++) {
    arr[i] = num + spread * (i - numIndex);
  }
  Chance.shuffle(arr);
  return arr;
};
Chance.generateMultipleChoices = function (
  length,
  expression,
  varValues,
  shuffle?,
) {
  const answer = Calculator.fixNumber(
    Calculator.evaluate(expression, varValues, false),
  );
  const choices = [answer];
  const wrongVars = [] as [number, number][];
  let nudgeRange = -length; //Allow up to [length] collisions before nudge occurs

  for (var v in varValues) {
    wrongVars[v] = [varValues[v], varValues[v]];
  }
  while (choices.length < length) {
    const vars = [] as number[];
    const modifiedVar = Chance.selectRandomKey(wrongVars);
    for (v in wrongVars) {
      const up = Chance.trueOrFalse();
      if (modifiedVar == v) {
        if (up) wrongVars[v]![1]++;
        else wrongVars[v]![0]--;
      }
      if (up) vars[v] = wrongVars[v]![1];
      else vars[v] = wrongVars[v]![0];
    }
    const key = ArrayUtil.join(vars, '_');
    let val = Calculator.fixNumber(
      Calculator.evaluate(expression, vars, false),
    );
    let divisionByZero = false;
    if (Calculator.isFraction(val)) {
      if (val[1] == 0) divisionByZero = true;
    }
    if (!divisionByZero) {
      if (nudgeRange > 0) val = Chance.nudge(val, nudgeRange);
      if (Calculator.equalsIn(val, choices)) {
        nudgeRange++;
      } else {
        choices.push(val);
      }
    }
  }
  if (shuffle) Chance.shuffle(choices);
  return choices;
};

/* Array */
Chance.shuffle = function (array) {
  const l = array.length;
  let i = l;
  while (i--) {
    const p = Math.floor(Math.random() * l);
    const t = array[i];
    array[i] = array[p];
    array[p] = t;
  }
};

Chance.dualShuffle = function (array1, array2) {
  /* This will shuffle 2 identical arrays the exact same way.  This is only safe if array2 is not null and has identical length to array1 */
  const l = array1.length;
  let i = l;
  while (i--) {
    const p = Math.floor(Math.random() * l);
    const t = array1[i];
    const tt = array2[i];
    array1[i] = array1[p];
    array2[i] = array2[p];
    array1[p] = t;
    array2[p] = tt;
  }
};

Chance.selectRandom = function (array) {
  if (array.length == 0) return null;
  else return array[Chance.randomInt(0, array.length - 1)];
};

Chance.selectRandomExcluding = function (array, excluding) {
  const choices = ArrayUtil.copy(array);
  ArrayUtil.removeAll(choices, excluding);
  return Chance.selectRandom(choices);
};

Chance.selectRandomKey = function (array) {
  let i = 0;
  for (const key in array) {
    const prob = 1.0 / (ArrayUtil.getLength(array) - i);
    if (Math.random() < prob) return key;
    i++;
  }
};
